<template>
  <car-approval-flow-core
    :question-id="questionId"
    :node-width="nodeWidth"
    :node-height="nodeHeight"
    :level-gap="levelGap"
    :node-gap="nodeGap"
  />
</template>

<script>
import KdApprovalFlow from "../kdProblemDetails/kdApprovalFlow.vue";
import { getFlowDiagram } from '@/api/feedback';

export default {
  name: "approvalFlow",
  components: {
    CarApprovalFlowCore: {
      name: "carApprovalFlowCore",
      extends: KdApprovalFlow,
      methods: {
        async loadFlowDiagram() {
          if (!this.questionId) return;
          try {
            const res = await getFlowDiagram(this.questionId);
            if (res.status === "0" && res.data) {
              this.applyFlowDiagramData(res.data);
            } else {
              this.resetFlowDiagramData();
            }
          } catch (error) {
            console.error("获取流程图数据失败:", error);
            this.resetFlowDiagramData();
          }
        },

        async loadFlowDiagramById(questionId) {
          if (!questionId) return;
          try {
            const res = await getFlowDiagram(questionId);
            if (res.status === "0" && res.data) {
              this.applyFlowDiagramData(res.data);
            } else {
              this.resetFlowDiagramData();
            }
          } catch (error) {
            console.error("获取流程图数据失败:", error);
            this.resetFlowDiagramData();
          }
        },
      },
    },
  },
  props: {
    questionId: {
      type: String,
      default: "",
    },
    nodeWidth: {
      type: Number,
      default: 130,
    },
    nodeHeight: {
      type: Number,
      default: 70,
    },
    levelGap: {
      type: Number,
      default: 80,
    },
    nodeGap: {
      type: Number,
      default: 34,
    },
  },
};
</script>
